import { userConstant } from "./constant";

export const breadcrumAction = (payload) => ({
    type: userConstant.BREAD_CRUM,
    payload: payload
})
